import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { Region } from '@paragon/contract-library';

interface RegionsSate {
  readonly regions: readonly Region[];
}

const initialState: RegionsSate = {
  regions: [],
};

const regionsSlice = createSlice({
  name: 'regions',
  initialState,
  reducers: {
    setRegions: (state, action: PayloadAction<readonly Region[]>) => {
      state.regions = castDraft(action.payload);
    },
  },
});

export const { setRegions } = regionsSlice.actions;
export const regions = regionsSlice.reducer;
